var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damageResultUptec view" }, [
    _c("div", { staticClass: "view_top" }, [
      _c("div", { staticClass: "navbarCategories" }, [
        _c("img", {
          staticClass: "check-img",
          attrs: { src: require("@/assets/images/self-care/arrow-left.png") },
          on: { click: _vm.handleClickPrevPage },
        }),
        _c("p", { staticClass: "grayLightMouse headline-medium" }, [
          _vm._v(_vm._s(_vm.stateWarrantyObjUptec.titleCat)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "view_content" }, [
      _c("p", [
        _vm._v(_vm._s(_vm.$t("damageMobilier.damageResultUptec.title")) + " "),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.stateWarrantyObjUptec.imageFeature,
              expression: "stateWarrantyObjUptec.imageFeature",
            },
          ],
          staticClass: "containerImgProduct mg mg--t-8",
        },
        [_c("img", { attrs: { src: _vm.stateWarrantyObjUptec.imageFeature } })]
      ),
      _c("p", { staticClass: "gray headline-large mg mg--t-8 mg--b-1" }, [
        _vm._v(_vm._s(_vm.stateWarrantyObjUptec.titleCat)),
      ]),
      _c("p", { staticClass: "gray text-medium-large" }, [
        _vm._v(_vm._s(_vm.stateWarrantyObjUptec.cat2)),
      ]),
      _c("p", { staticClass: "gray text-medium-large mg mg--b-3" }, [
        _vm._v(_vm._s(_vm.stateWarrantyObjUptec.cat1)),
      ]),
      _c("p", { staticClass: "text-small-bold black mg mg--b-1" }, [
        _vm._v(_vm._s(_vm.$t("damageMobilier.category.date")) + " "),
      ]),
      _c("p", { staticClass: "text-medium-large mg mg--b-4" }, [
        _vm._v(_vm._s(_vm.stateWarrantyObjUptec.date)),
      ]),
      _vm.stateWarrantyObjUptec.price
        ? _c("div", { staticClass: "price-container" }, [
            _c("p", { staticClass: "text-small-bold black mg mg--b-1" }, [
              _vm._v(_vm._s(_vm.$t("damageMobilier.category.price")) + " "),
            ]),
            _c("p", { staticClass: "text-medium-large mg mg--b-3" }, [
              _vm._v(_vm._s(_vm.stateWarrantyObjUptec.price)),
            ]),
          ])
        : _vm._e(),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.getImageSrc(
                  "inputImgEnsemble",
                  _vm.stateWarrantyObjUptec.images
                ).length >= 1,
              expression:
                'getImageSrc("inputImgEnsemble", stateWarrantyObjUptec.images).length >=1',
            },
          ],
          staticClass: "images-list_container mg mg--b-4",
        },
        [
          _c("p", { staticClass: "text-small-bold gray mg mg--b-2" }, [
            _vm._v(_vm._s(_vm.$t("damagesConfirmed.photosEnsemble"))),
          ]),
          _vm._l(
            _vm.getImageSrc(
              "inputImgEnsemble",
              _vm.stateWarrantyObjUptec.images
            ),
            function (image) {
              return _c("li", [_c("img", { attrs: { src: image } })])
            }
          ),
        ],
        2
      ),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.getImageSrc(
                  "inputImgPres",
                  _vm.stateWarrantyObjUptec.images
                ).length >= 1,
              expression:
                'getImageSrc("inputImgPres", stateWarrantyObjUptec.images).length >=1',
            },
          ],
          staticClass: "images-list_container mg mg--b-4",
        },
        [
          _c("p", { staticClass: "text-small-bold gray mg mg--b-2" }, [
            _vm._v(_vm._s(_vm.$t("damagesConfirmed.photosPres"))),
          ]),
          _vm._l(
            _vm.getImageSrc("inputImgPres", _vm.stateWarrantyObjUptec.images),
            function (image) {
              return _c("li", [_c("img", { attrs: { src: image } })])
            }
          ),
        ],
        2
      ),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _c("ma-accept-damages", {
          staticClass: "buttonAddDamages",
          attrs: {
            handleButtonClick: _vm.handleClickGoToDamagesView,
            title: "Accepter",
            btnType: "functionalBtn",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }